function CustomLinkButton({style_classes, link, size, path}) {
    return (
        <a className={style_classes} href={link} target="_blank" rel="noopener noreferrer">
            {path ?
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                aria-hidden="true"
                className="fill-current">
                <path
                    d={path}></path>
            </svg>
            :
            <span className="text-xl md:text-2xl font-extrabold">in</span>
            }
        </a>
    )
}

export default CustomLinkButton;